module.exports = __webpack_public_path__ + "static/td_preview-64c05d0474f973dafdf4675eca2a4ccd.jpg";